export default "__VITE_ASSET__BUdFa3T___"